import { ToastProps } from 'lib/Toaster';
import { NotificationType, ToastId, ToastPayload } from './types';

const NotificationLabels: Record<NotificationType, string> = {
  Failure: 'Something went wrong',
  Warning: 'Warning',
  Info: 'Information',
  Success: 'Success',
};

const FRAME_COUNT_EXCEEDS_LIMIT = 'FrameCountExceedsLimit';
const CAMPAIGN_RESTRICTION_HEADER = 'Deal Restriction';

type ApiErrorResponse = {
  status?: number;
  data?: { code?: string; message?: string };
};

export const isFrameCountExceedsLimitError = (error: unknown): boolean => {
  const response = (error as { response?: ApiErrorResponse } | undefined)?.response;
  return response?.status === 413 && response.data?.code === FRAME_COUNT_EXCEEDS_LIMIT;
};

const getFrameCountExceedsLimitToast = (error: unknown): { header: string; description: string } | undefined => {
  if (!isFrameCountExceedsLimitError(error)) return undefined;

  const message = (error as { response?: ApiErrorResponse }).response?.data?.message;
  const parsedLimit = Number(message?.match(/maximum of ([\d,]+)/i)?.[1]?.replace(/,/g, ''));
  const formattedLimit = Number.isFinite(parsedLimit) ? parsedLimit.toLocaleString('en-US') : undefined;

  if (formattedLimit) {
    return {
      header: CAMPAIGN_RESTRICTION_HEADER,
      description: `Deals are limited to ${formattedLimit} frames. Please contact your VIOOH Partnership Director or VIOOH Operations for more information.`,
    };
  }

  return {
    header: CAMPAIGN_RESTRICTION_HEADER,
    description: `This deal exceeds the upper frame limits. Please contact your VIOOH Partnership Director or VIOOH Operations for more information.`,
  };
};

export const generateToastMessage = ({
  id,
  type,
  error,
  header,
  timeout,
  description,
}: ToastPayload & { id: ToastId }): ToastProps => {
  const frameCountToast = getFrameCountExceedsLimitToast(error);

  return {
    id,
    header: header ?? frameCountToast?.header ?? NotificationLabels[type],
    description:
      description ||
      frameCountToast?.description ||
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message,
    type,
    timeout,
  };
};
